const expressions: readonly [RegExp, string][] = [
  [/(?:^|\s)(today|امروز)(?=$|\s)/iu, 'today'],
  [/(?:^|\s)(yesterday|دیروز)(?=$|\s)/iu, 'yesterday'],
  [/(?:^|\s)(tomorrow|فردا)(?=$|\s)/iu, 'tomorrow'],
  [/(?:^|\s)(this week|این هفته)(?=$|\s)/iu, 'currentWeek'],
  [/(?:^|\s)(last week|previous week|هفته قبل|هفته گذشته)(?=$|\s)/iu, 'previousWeek'],
  [/(?:^|\s)(this month|current month|این ماه)(?=$|\s)/iu, 'currentMonth'],
  [/(?:^|\s)(last month|previous month|ماه قبل|ماه گذشته)(?=$|\s)/iu, 'previousMonth'],
  [/(?:^|\s)(this year|current year|امسال|سال جاری)(?=$|\s)/iu, 'currentYear'],
  [/(?:^|\s)(last fiscal year|previous fiscal year|سال مالی قبل)(?=$|\s)/iu, 'previousFiscalYear'],
];

export function extractDateExpression(value: string): string | undefined {
  return expressions.find(([pattern]) => pattern.test(value))?.[1];
}
